module.exports = __webpack_public_path__ + "static/media/manage-content.214ee48a.svg";